<template>
  <div class="main-pagination row no-gutters justify-content-center">
    <inline-svg
      class="arrow"
      v-if="nums[0] > 1"
      style="transform: rotate(180deg)"
      @click="$router.push({ params: { id: 1 } })"
      :src="require('@/assets/icons/2arrow.svg')"
    />
    <inline-svg
      class="arrow"
      style="transform: rotate(0deg)"
      v-if="page != 1"
      @click="$router.push({ params: { id: page - 1 } })"
      :src="require('@/assets/icons/arrow.svg')"
    />
    <a class="etc" v-if="nums[0] > 1">...</a>
    <div class="main">
      <a
        class="number"
        v-for="(num, index) in nums"
        :key="index"
        :class="{ active: num == page }"
        @click="$router.push({ query: { page: num } })"
      >
        {{ num }}
      </a>
    </div>
    <a class="etc" v-show="nums[nums.length - 1] < n">...</a>
    <inline-svg
      class="arrow"
      v-if="page != n"
      style="transform: rotate(180deg)"
      @click="$router.push({ query: { page: Number(page) + 1 } })"
      :src="require('@/assets/icons/arrow.svg')"
    />
    <inline-svg
      class="arrow"
      v-if="nums[nums.length - 1] < n"
      style="transform: rotate(0deg)"
      @click="$router.push({ query: { page: n } })"
      :src="require('@/assets/icons/2arrow.svg')"
    />
  </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";

export default {
  name: "Pagination",
  components: {
    InlineSvg,
  },
  props: {
    n: {
      type: Number,
      default: 1,
    },
    page: {
      default: 1,
    },
    max: {
      default: 1,
    },
    link: {
      default: "/",
    },
  },
  data() {
    return {
      nums: "",
    };
  },
  watch: {
    page(to) {
      this.pages(to);
    },
  },
  created() {
    this.pages(this.page);
  },
  methods: {
    pages(e) {
      if (e < this.max - 1) {
        this.number(0);
      } else if (e > this.n - (this.max - 1)) {
        if (this.n <= this.max) {
          this.number(0);
        } else {
          this.number(this.n - this.max);
        }
      } else {
        this.number(e - (this.max - 1));
      }
    },
    number(e) {
      var a = [0];
      for (let i = 0; i < this.max; i++) {
        a[i] = e + i + 1;
        if (e + i + 1 >= this.n) {
          break;
        }
      }
      this.nums = a;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-pagination {
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.main {
  display: flex;
  gap: 10px;
}

.number {
  font-weight: 600;
  cursor: pointer;
  height: 20px;
  width: 20px;
  border: 1px solid transparent;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.number:hover {
  border: 1px solid var(--yellow);
  border-radius: 5px;
  color: var(--yellow);
}

.number.active {
  background-color: var(--yellow);
  color: white;
}

.etc {
  margin: -3px 10px 0 10px;
  cursor: pointer;
}

.etc-n {
  cursor: pointer;
}

.etc-n:hover {
  color: var(--yellow);
}

.arrow {
  padding: 0 10px;
  margin: 0 10px;

  &:first-of-type {
    margin: 0;
    transform: rotate(180deg);
  }

  &:nth-of-type(2) {
  }

  &:nth-of-type(3) {
    /*transform: rotate(180deg);*/
  }

  &:last-of-type {
    margin: 0;
    /*transform: rotate(180deg);*/
  }
}

.arrow:hover {
  color: var(--yellow);
  cursor: pointer;
}
</style>
